module.exports = __webpack_public_path__ + "static/media/Countryicon.37893996.svg";